export var AnalyticsProviderType;
(function (AnalyticsProviderType) {
  AnalyticsProviderType[AnalyticsProviderType["CONSOLE"] = 1] = "CONSOLE";
  AnalyticsProviderType[AnalyticsProviderType["GOOGLE"] = 2] = "GOOGLE";
  AnalyticsProviderType[AnalyticsProviderType["APP_INSIGHTS"] = 3] = "APP_INSIGHTS";
  AnalyticsProviderType[AnalyticsProviderType["ALL"] = 1000] = "ALL";
})(AnalyticsProviderType || (AnalyticsProviderType = {}));